import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import Tooltip from '@mui/material/Tooltip';

export const NavButton =
  // eslint-disable-next-line react/prop-types
  React.forwardRef(({title, ...props}, ref) => (
    <Button
      color="inherit"
      size="small"
      sx={{marginLeft: 1}}
      {...props}
      ref={ref}
    />
  ));

const MenuButton = ({
  label,
  children,
  buttonComponent,
  title,
  menuProps,
  closeOnClick = true,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const ButtonComponent = buttonComponent || NavButton;

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuItems = React.Children.toArray(children).map(child =>
    React.cloneElement(child, {
      onClick: event => {
        closeOnClick && handleClose(event);
        if (child.props.onClick) {
          child.props.onClick();
        }
      },
    })
  );

  return (
    <React.Fragment>
      <Tooltip title={title || ''} placement="bottom">
        <ButtonComponent onClick={handleClick} {...props}>
          {label}
        </ButtonComponent>
      </Tooltip>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
        {...menuProps}
      >
        {menuItems}
      </Menu>
    </React.Fragment>
  );
};

MenuButton.propTypes = {
  menuProps: PropTypes.object,
  label: PropTypes.node,
  buttonComponent: PropTypes.object,
  children: PropTypes.node,
  title: PropTypes.node,
  closeOnClick: PropTypes.bool,
};

export default MenuButton;
